var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#0c192b;}.cls-4{fill:#0f2033;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30,
    height: 30
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.56,
    y: 7.71,
    width: 19.6,
    height: 15.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.35,
    y1: 26.14,
    x2: 12.52,
    y2: 5.4,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc1fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 18.61,
    y1: 28.61,
    x2: 7.79,
    y2: 7.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 20.97,
    y1: 27.38,
    x2: 10.14,
    y2: 6.64,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_51",
    "data-name": "Layer 51"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    className: "cls-3",
    width: 30,
    height: 30,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    className: "cls-4",
    d: "M0,7A7,7,0,0,1,7,0h6.47a16.39,16.39,0,0,1,.81,5.1A16.32,16.32,0,0,1,0,21.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M8.75,19.43a.67.67,0,0,1,.45-.18H24.84a.32.32,0,0,1,.23.54L22,22.88a.64.64,0,0,1-.45.19H5.88a.32.32,0,0,1-.22-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M8.75,7.9a.64.64,0,0,1,.45-.19H24.84a.32.32,0,0,1,.23.55L22,11.35a.63.63,0,0,1-.45.18H5.88A.32.32,0,0,1,5.66,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22,13.63a.64.64,0,0,0-.45-.19H5.88a.32.32,0,0,0-.22.55l3.09,3.09a.64.64,0,0,0,.45.19H24.84a.32.32,0,0,0,.23-.55Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.b2806b740b3d434103d0f370095871dc.svg";
export { ForwardRef as ReactComponent };